module.exports = __webpack_public_path__ + "media/images/users/user-2-fb4ade3e3a86c9e16a7a2d23ac61c56d.jpg";